var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgVacation = function SvgVacation(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 117,
    viewBox: "0 0 232 117",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.319 87.9441C185.835 85.807 183.417 84.5467 180.835 84.5467H158.417L151.385 74.2449C149.901 72.053 147.428 70.7927 144.791 70.7927H111.275L107.978 58.4634C107.758 57.6415 106.934 57.1483 106.11 57.3675L101.604 58.573C100.78 58.7922 100.286 59.6142 100.505 60.4361L108.582 90.4647L100.396 107.178L107.319 110.575L116.11 92.4922C116.22 92.2182 116.33 91.9442 116.385 91.6702H180.78C181 91.6702 181.22 91.7798 181.385 91.999L196.879 114.685L202.758 110.685L187.319 87.9441ZM144.791 75.0668C145.945 75.0668 147.044 75.6696 147.703 76.6012L153.033 84.4371H114.956L112.428 75.0121H144.791V75.0668Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M222.154 116H12.4285C28.857 106.246 50.7801 99.013 72.8131 99.3418C99.1318 99.7254 124.406 105.808 131.275 109.15C150.121 108 174.077 103.068 186.604 103.452C197.264 103.835 212.758 106.685 222.154 116Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231 116H222.154H12.4286H1",
    stroke: "#D5DAE8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6264 105.589C83.4725 105.589 82.4286 104.767 82.2088 103.616L62.7582 2.95432C62.4835 1.6392 63.3626 0.32408 64.7363 0.0500959C66.0549 -0.223888 67.3736 0.65286 67.6483 2.02278L87.0989 102.63C87.3736 103.945 86.4945 105.26 85.1209 105.534C84.9011 105.589 84.7912 105.589 84.6264 105.589Z",
    fill: "#ADB6C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6045 53.9154C51.6594 53.5866 51.7693 53.3127 51.8792 52.9839C51.9342 53.4771 51.9342 53.9702 51.9891 54.4634C51.8792 54.2442 51.7144 54.0798 51.6045 53.9154Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2857 45.3671C95.2308 45.4219 95.2308 45.5315 95.2308 45.5863C95.1758 45.4219 95.1209 45.2575 95.0659 45.0383C95.1209 45.1479 95.2308 45.2575 95.2857 45.3671Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.588 46.944C181.087 46.944 189.599 38.4555 189.599 27.9843C189.599 17.5132 181.087 9.02466 170.588 9.02466C160.088 9.02466 151.577 17.5132 151.577 27.9843C151.577 38.4555 160.088 46.944 170.588 46.944Z",
    fill: "#FFE2A8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5825 111.123C45.7254 107.835 50.1759 108.602 51.9891 109.26",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8022 107.726C78.3077 104.931 84.1869 107.068 84.6264 109.205",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3735 113.041C93.1428 111.945 94.901 111.123 96.0548 111.89",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.802 112.329C168.363 110.849 168.582 111.781 169.736 112.329",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M179.242 111.123C179.736 110.246 182.154 110.63 182.154 110.63",
    stroke: "#ADB6C8",
    strokeWidth: 0.918069,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.066 30.1883C125.451 27.8868 120.066 27.0101 114.571 28.0512C105.066 29.8047 97.8132 36.7091 95.2857 45.367C95.2308 45.4218 95.2308 45.5314 95.2308 45.5862C95.1758 45.4218 95.1209 45.2574 95.0659 45.0382C89.5714 38.079 80.4505 34.2433 71.0549 35.9968C61.6593 37.6955 54.5165 44.4902 51.8791 52.9837C51.9341 53.4769 51.9341 53.9701 51.989 54.4632C51.8791 54.2989 51.7143 54.0797 51.6044 53.9153C46.1648 46.4081 36.7692 42.2984 27.044 44.0519C21.9341 44.9834 17.4286 47.4493 14.022 50.8467C19.956 27.1197 39.2967 7.77644 65.011 3.11872C90.945 -1.6486 116.11 9.80392 130.066 30.1883Z",
    fill: "url(#paint1_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0658 45.0382C89.5713 38.079 80.4505 34.2432 71.0548 35.9967C61.6592 37.6954 54.5164 44.4902 51.879 52.9837C49.6812 25.9689 54.7911 4.98178 65.0658 3.11869C75.2856 1.2556 87.4834 19.0645 95.0658 45.0382Z",
    fill: "#EAEEF9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 151.585,
    y1: 59.3084,
    x2: 151.585,
    y2: 91.5093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7CFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4BDCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 14.022,
    y1: 2.04346,
    x2: 116.42,
    y2: 70.2156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5271F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D60F3"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVacation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vacation.13241621.svg";
export { ForwardRef as ReactComponent };